var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.548 21.916c9.057 0 14.01-7.503 14.01-14.01 0-.213-.005-.425-.014-.636A10.017 10.017 0 0024 4.72a9.83 9.83 0 01-2.828.775 4.94 4.94 0 002.165-2.723 9.869 9.869 0 01-3.126 1.195 4.925 4.925 0 00-8.391 4.49A13.98 13.98 0 011.67 3.313a4.907 4.907 0 00-.666 2.475 4.92 4.92 0 002.19 4.098 4.888 4.888 0 01-2.23-.616v.063a4.926 4.926 0 003.95 4.827 4.94 4.94 0 01-2.224.085 4.93 4.93 0 004.6 3.42 9.88 9.88 0 01-6.115 2.108A9.9 9.9 0 010 19.704a13.941 13.941 0 007.548 2.212z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}

var MemoSvgTwitter = /*#__PURE__*/React.memo(SvgTwitter);
export default MemoSvgTwitter;